import React, { Component } from 'react'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'

export default class ModalFirstVisit extends Component {
  state = { modalOpen: true }

  handleClose = () => {
    this.setState({ modalOpen: false })
    localStorage.setItem('modalOpen', false);
  }

  hydrateStateWithLocalStorage() {
    // for all items in state
    for (let key in this.state) {
      // if the key exists in localStorage
      if (localStorage.hasOwnProperty(key)) {
        // get the key's value from localStorage
        let value = localStorage.getItem(key);

        // parse the localStorage string and setState
        try {
          value = JSON.parse(value);
          this.setState({ [key]: value });
        } catch (e) {
          // handle empty string
          //this.setState({ [key]: value });
        }
      }
    }
  }

  componentWillMount() {
    this.hydrateStateWithLocalStorage()
  }

  render() {
    return (
      <Modal
        open={this.state.modalOpen}
        onClose={this.handleClose}
        basic
        size='small'>
        <Header icon='pills' content='Content Advisory' />
        <Modal.Content>
          <h3>This website discusses experimental drug usage.</h3>
          <h2>Do you want to continue to this site?</h2>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={this.handleClose} inverted>
            <Icon name='checkmark' /> Proceed
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modalFirstVisit.js